import { render, staticRenderFns } from "./CommercialProjectionReportView.vue?vue&type=template&id=00725543&scoped=true&lang=pug&"
import script from "./CommercialProjectionReportView.vue?vue&type=script&lang=js&"
export * from "./CommercialProjectionReportView.vue?vue&type=script&lang=js&"
import style0 from "./CommercialProjectionReportView.vue?vue&type=style&index=0&id=00725543&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00725543",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VSpacer})
